import config from 'services/config'

export const getImgUrlFromCDN = (fileName, mediaTag, hotelId) => {
  const mediaTagRegex = new RegExp(`^c/|a/`)
  const cleanFileName = fileName.replace(mediaTagRegex, '')

  return `${config.inviteMediaBaseUrl}/${hotelId}/${mediaTag}/${cleanFileName}`
}

export const isCampaignImageVisible = mediaUrl => {
  const extension = getExtensionFromUrl(mediaUrl)
  return extension !== 'pdf'
}

export const getExtensionFromUrl = url => {
  if (!url) {
    return ''
  }

  const withoutQuery = url.split('?')[0].split('#')[0]
  const match = withoutQuery.match(/\.(\w+)$/i)

  return match ? match[1].toLowerCase() : ''
}

export const getCommonCampaignMedia = campaigns => {
  if (!campaigns) {
    return []
  }

  const salesCampaigns = campaigns.filter(
    c => c.kind === 'Sales' && c.category !== 'CardAbandonmentOptedIn'
  )

  if (!salesCampaigns.length) {
    return []
  }

  const commonMediaUrl = salesCampaigns[0].messageMediaUrls?.[0] ?? null

  const allCampaignsShareMedia = salesCampaigns.every(
    c => (c.messageMediaUrls?.[0] ?? null) === commonMediaUrl
  )

  if (allCampaignsShareMedia && commonMediaUrl) {
    return salesCampaigns[0].messageMediaUrls
  }

  return []
}
